/* eslint-disable */
//this file can remain empty, required for ajax-functions.php
$ = jQuery;

let word = '';
let elamyspalvelutCats = [];
let soveltuvuusCats = [];
let seasonsCats = [];

if($('#activity-filters').length > 0) {
  checkUrlParams();
}

$('.open-filters a').on('click', function(e) {
  e.preventDefault();
  $('.filters-filters').toggleClass('opened');
});

$('#search-activity-word').on('click', function(e) {
  e.preventDefault();
  word = $('.searchbar-container input[type="text"]').val();
  
  let params = {
    word: word,
    elamyspalvelut: elamyspalvelutCats,
    soveltuvuus: soveltuvuusCats,
    seasons: seasonsCats,
  };

  doSearch(params);
  urlFilterParams(params);
  createButtons(params);
});

$('#clear-activity-filters').on('click', function(e) {
  e.preventDefault();
  // Uncheck all checkboxes
  $('.category-item input[type="checkbox"]').prop('checked', false);
  $('.searchbar-container input[type="text"]').val('');

  // Clear all selected categories arrays
  elamyspalvelutCats = [];
  soveltuvuusCats = [];
  seasonsCats = [];
  word = '';

  // Clear all filter buttons (assuming a container for filter buttons, update selector as needed)
  $('.filter-buttons-container').empty();

  // Clear URL params (remove category/search params from current URL without reloading)
  if (window.history.replaceState) {
    const url = new URL(window.location);
    url.search = ''; // Remove all search parameters
    window.history.replaceState({}, document.title, url.pathname);
  }

  // Do the search and recreate buttons
  doSearch({
    word: word,
    elamyspalvelut: elamyspalvelutCats,
    soveltuvuus: soveltuvuusCats,
    seasons: seasonsCats,
  });

  $('.filters-container').addClass('no-filters');
});

// checkbox functionality
$('.category-item input[type="checkbox"]').on('change', function() {
  const categoryName = $(this).attr('name');

  var checked = $(this).is(':checked');

  var combined = {
    id: $(this).val(),
    slug: $(this).data('slug'),
    label: $(this).data('name'),
  };

  if (categoryName == 'elamyspalvelu[]') {
    if (checked) {
      elamyspalvelutCats.push(combined);
    } else {
      elamyspalvelutCats = elamyspalvelutCats.filter(function(item) {
        return item.id !== combined.id;
      });
    }
  } else if (categoryName == 'soveltuvuus[]') {
    if (checked) {
      soveltuvuusCats.push(combined);
    } else {
      soveltuvuusCats = soveltuvuusCats.filter(function(item) {
        return item.id !== combined.id;
      });
    }
  } else if (categoryName == 'season[]') {
    if (checked) {
      seasonsCats.push(combined);
    } else {
      seasonsCats = seasonsCats.filter(function(item) {
        return item.id !== combined.id;
      });
    }
  }

  let params = {
    elamyspalvelut: elamyspalvelutCats,
    soveltuvuus: soveltuvuusCats,
    seasons: seasonsCats,
    word: word,
  };

  doSearch(params);
  urlFilterParams(params);
  createButtons(params);
});

function urlFilterParams(params) {
  var url = new URL(window.location.href);
  // Remove all relevant filter parameters first
  ['elamyspalvelut', 'soveltuvuus', 'seasons', 'word'].forEach(function(key) {
    url.searchParams.delete(key);
  });

  // Add params if they exist and are not empty
  if (params) {
    if (params.elamyspalvelut && params.elamyspalvelut.length > 0) {
      // join slugs with commas
      url.searchParams.set('elamyspalvelut', params.elamyspalvelut.map(function(item) { return item.slug; }).join(','));
    }
    if (params.soveltuvuus && params.soveltuvuus.length > 0) {
      url.searchParams.set('soveltuvuus', params.soveltuvuus.map(function(item) { return item.slug; }).join(','));
    }
    if (params.seasons && params.seasons.length > 0) {
      url.searchParams.set('seasons', params.seasons.map(function(item) { return item.slug; }).join(','));
    }
    if (params.word && params.word.length > 0) {
      url.searchParams.set('word', params.word);
    }
  }

  // Update URL without reloading
  window.history.replaceState({}, '', url.pathname + url.search);
}

function checkUrlParams() {
  let hasFilters = false;
  var url = new URL(window.location.href);
  var elamyspalvelutUrlParam = url.searchParams.get('elamyspalvelut');
  var soveltuvuusUrlParam = url.searchParams.get('soveltuvuus');
  var seasonsUrlParam = url.searchParams.get('seasons');
  var wordUrlParam = url.searchParams.get('word');

  if(elamyspalvelutUrlParam) {
    var elamyspalvelut = elamyspalvelutUrlParam.split(',');
    elamyspalvelut.forEach(function(item) {
      item = item.replace(' ', '-');
      let element = $('input[name="elamyspalvelu[]"][data-slug="' + item + '"]');
      element.prop('checked', true);

      elamyspalvelutCats.push({
        id: element.val(),
        slug: element.data('slug'),
        label: element.data('name'),
      });
    });
    hasFilters = true;
  }

  if(soveltuvuusUrlParam) {
    var soveltuvuus = soveltuvuusUrlParam.split(',');
    soveltuvuus.forEach(function(item) {
      let element = $('input[name="soveltuvuus[]"][data-slug="' + item + '"]');
      element.prop('checked', true);

      soveltuvuusCats.push({
        id: element.val(),
        slug: element.data('slug'),
        label: element.data('name'),
      });
    });
    hasFilters = true;
  }

  if(seasonsUrlParam) {
    var seasons = seasonsUrlParam.split(',');
    seasons.forEach(function(item) {
      let element = $('input[name="season[]"][data-slug="' + item + '"]');
      element.prop('checked', true);

      seasonsCats.push({
        id: element.val(),
        slug: element.data('slug'),
        label: element.data('name'),
      });
    });
    hasFilters = true;
  }

  if(wordUrlParam) {
    word = wordUrlParam;
    $('.searchbar-container input[type="text"]').val(word);
    hasFilters = true;
  }

  if(hasFilters) {
    $('.filters-container').removeClass('no-filters');
  }

  let params = {
    elamyspalvelut: elamyspalvelutCats,
    soveltuvuus: soveltuvuusCats,
    seasons: seasonsCats,
    word: word,
  };

  if(hasFilters) {
    doSearch(params);
    createButtons(params);
  }
}

function createButtons(params) {
  // Empty filter-buttons-container before re-adding buttons to avoid duplicates
  $('.filter-buttons-container').empty();

  // Append buttons and set up click events for removal and filter updating
  if(params.elamyspalvelut.length > 0) {
    params.elamyspalvelut.forEach(function(item) {
      let itemId = item.slug + '-' + item.id;

      var $btn = $('<button class="filter-button" data-button="' + itemId + '">' + item.label + '</button>');
      $btn.on('click', function(e) {
        e.preventDefault();
        $("input[value=" + item.id + "]").prop('checked', false).trigger('change');
        params.elamyspalvelut = params.elamyspalvelut.filter(function(i) {
          return i.id !== item.id;
        });
        $(this).remove();
        doSearch(params);
        createButtons(params); // Refresh buttons
        urlFilterParams(params);
      });
      $('.filter-buttons-container').append($btn);
    });
  }

  if(params.soveltuvuus.length > 0) {
    params.soveltuvuus.forEach(function(item) {
      var $btn = $('<button class="filter-button" data-button="' + item.id + '">' + item.label + '</button>');
      $btn.on('click', function(e) {
        e.preventDefault();
        $("input[value=" + item.id + "]").prop('checked', false).trigger('change');
        params.soveltuvuus = params.soveltuvuus.filter(function(i) {
          return i.id !== item.id;
        });
        $(this).remove();
        doSearch(params);
        createButtons(params);
        urlFilterParams(params);
      });
      $('.filter-buttons-container').append($btn);
    });
  }

  if(params.seasons.length > 0) {
    params.seasons.forEach(function(item) {
      let itemId = item.slug + '-' + item.id;
      var $btn = $('<button class="filter-button" data-button="' + itemId + '">' + item.label + '</button>');
      $btn.on('click', function(e) {
        e.preventDefault();
        $("input[value=" + item.id + "]").prop('checked', false).trigger('change');
        params.seasons = params.seasons.filter(function(i) {
          return i.label !== item.label;
        });
        $(this).remove();
        doSearch(params);
        createButtons(params);
        urlFilterParams(params);
      });
      $('.filter-buttons-container').append($btn);
    });
  }

  if(params.word && params.word.length > 0) {
    var $btn = $('<button class="filter-button" data-word="' + params.word + '">' + params.word + '</button>');
    $btn.on('click', function(e) {
      e.preventDefault();
      params.word = '';
      $('.searchbar-container input[type="text"]').val(''); // Optionally clear the search bar
      $(this).remove();
      word = '';
      doSearch(params);
      createButtons(params);
      urlFilterParams(params);
    });
    $('.filter-buttons-container').append($btn);
  }
}

function doSearch(params) {
  let lang = 'fi';

  lang = $('html').attr('lang');
  
  if(lang == 'en-GB') {
    lang = 'en';
  }

  if(params.elamyspalvelut.length == 0 && params.soveltuvuus.length == 0 && params.seasons.length == 0 && params.word == '') {
    $('.filters-container').addClass('no-filters');
  } else {
    $('.filters-container').removeClass('no-filters');
  }

  $.ajax({
    url: window.frontendajax.ajaxurl,
    type: 'POST',
    data: {
      action: 'acitvity_filtering',
      params: params,
      lang: lang,
    },
    beforeSend: function() {
      $('.results-container.single-activity-card').remove();
    },
    success: function(response) {
      let res = JSON.parse(response);

      $('.results-container').html(res.html);

      if(res.count == 0) {
        $('.no-results-container').removeClass('hidden');
      } else {
        $('.no-results-container').addClass('hidden');
      }
    },
    error: function(error) {
      console.log(error);
    },
  });
}

/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/autoload/ajaxcalls.js